export const COMMON_CATEGORIES = ['News', 'All'];

export const NEW_CATEGORIES = [
  'Remote Working & Freelancing',
  'Tips for Hiring',
  'Success Stories',
  'Writing',
  'Design & Creative',
  'Engineering, Dev & IT',
  'Social Media',
  'Marketing',
  'How-to',
  'AI & the Future of Work',
  'Tools, Software and Programming Languages',
  'Ethics & AI',
  'Trends',
];
